import React from 'react';
const RootContext = React.createContext({
    eteTheme: {},
    theme: {},
    setTheme: () => {},
    clearTheme: () => {},
});
export default RootContext;
